/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_1Inputs */

const en_pc_tut_forms_1 = /** @type {(inputs: Pc_Tut_Forms_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Fill & Sign, click a field and type. Checkboxes, radio buttons and lists behave as the author designed.`)
};

const zh_pc_tut_forms_1 = /** @type {(inputs: Pc_Tut_Forms_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开「Fill & Sign」，点击字段直接输入。复选框、单选按钮和列表都按作者的设计工作。`)
};

/**
* | output |
* | --- |
* | "Open Fill & Sign, click a field and type. Checkboxes, radio buttons and lists behave as the author designed." |
*
* @param {Pc_Tut_Forms_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_1 = /** @type {((inputs?: Pc_Tut_Forms_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_1(inputs)
	return zh_pc_tut_forms_1(inputs)
});
export { pc_tut_forms_1 as "pc.tut.forms.1" }